<div class="modal-dialog">
  <div class="modal-body mb-6">
    <div class="flex items-center gap-2">
      <img src="/assets/exclamation-triangle-warning.svg" class="modal-icon" />
      <div [innerHTML]="message"></div>
    </div>
  </div>
  @if (this.closable) {
    <footer class="flex content-center justify-end mt-4">
      <p-button styleClass="btn-contrast" (click)="close()">{{ closeLabel }}</p-button>
    </footer>
  }
</div>
